import { useContext } from "react";

import { CommunityFeedContext } from "../CommunityFeedProvider";

export const useCommunityFeed = () => {
  const context = useContext(CommunityFeedContext);
  if (context === undefined) {
    throw new Error(
      "useCommunityFeed must be used within a CommunityFeedProvider",
    );
  }
  return context;
};
